import {AfterViewInit, Directive, ElementRef, HostListener, Input, OnInit, Renderer2} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[percentFormatter]'
})
export class PercentFormatterDirective implements AfterViewInit {

  @Input() needPercentFormatter: boolean = false;

  constructor(private el: ElementRef, private renderer: Renderer2, private control: NgControl) {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.needPercentFormatter) {
        const initialValue = this.control.control?.value;
        if (initialValue !== null && initialValue !== undefined) {
          this.format(initialValue);
        }
      }
    }, 250);
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string) {
    if (this.needPercentFormatter) {
      this.format(value);
    }
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value: string) {
    if (this.needPercentFormatter) {
      this.el.nativeElement.value = this.parse(value);
    }
  }

  private format(value: string) {
    setTimeout(() => {
      if (this.needPercentFormatter) {
        const trimmedValue = value.toString()?.trim();
        this.el.nativeElement.value = (trimmedValue !== null && trimmedValue !== undefined && trimmedValue !== '' && !isNaN(+trimmedValue)) ? Number(trimmedValue) + '%' : '';
      }
    }, 1);
  }

  private parse(value: string): string {
    if (this.needPercentFormatter) {
      return value.replace('%', '');
    }
  }

}
